import { TranslocoPipe, provideTranslocoScope } from '@jsverse/transloco';
import { Component } from '@angular/core';

@Component({
  providers: [provideTranslocoScope('products')],
  selector: 'prd-products',
  imports: [TranslocoPipe, ],
  templateUrl: './products.html',
  styleUrl: './products.scss',
})
export class Products {

}
